/* tslint:disable */
/* eslint-disable */
/**
 * NoRadio Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FileId } from './FileId';
import { FileIdFromJSON, FileIdFromJSONTyped, FileIdToJSON } from './FileId';

/**
 *
 * @export
 * @interface ShowCreateModel
 */
export interface ShowCreateModel {
    /**
     *
     * @type {string}
     * @memberof ShowCreateModel
     */
    title: string;
    /**
     *
     * @type {string}
     * @memberof ShowCreateModel
     */
    type: string;
    /**
     *
     * @type {FileId}
     * @memberof ShowCreateModel
     */
    fileId?: FileId;
}

/**
 * Check if a given object implements the ShowCreateModel interface.
 */
export function instanceOfShowCreateModel(value: object): boolean {
    if (!('title' in value)) return false;
    if (!('type' in value)) return false;
    return true;
}

export function ShowCreateModelFromJSON(json: any): ShowCreateModel {
    return ShowCreateModelFromJSONTyped(json, false);
}

export function ShowCreateModelFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): ShowCreateModel {
    if (json == null) {
        return json;
    }
    return {
        title: json['title'],
        type: json['type'],
        fileId: json['file_id'] == null ? undefined : FileIdFromJSON(json['file_id']),
    };
}

export function ShowCreateModelToJSON(value?: ShowCreateModel | null): any {
    if (value == null) {
        return value;
    }
    return {
        title: value['title'],
        type: value['type'],
        file_id: FileIdToJSON(value['fileId']),
    };
}
